import React, { useState, useEffect } from 'react';
import axios from 'axios';

const WeatherMini = ({ coordsString }) => {
  // coordsString sisu on "40.313946;23.063519"
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    if (!coordsString) return;

    // 1. Lõikame sõne pooleks
    const [lat, lon] = coordsString.split(';').map(val => parseFloat(val));

    if(lat === 0 && lon === 0) {
      return;
    }

    const fetchWeather = async () => {
      try {
        const res = await axios.get('https://weather.bercman.com/weather', {
          params: { lat, lon }
        });
        setWeather(res.data);
      } catch (err) {
        console.error("Ilma päring ebaõnnestus:", err.message);
      }
    };

    if (!isNaN(lat) && !isNaN(lon)) {
      fetchWeather();
    }
  }, [coordsString]);

  if (!weather) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img 
        src={weather.current.condition.icon} 
        alt="icon" 
        style={{ width: '40px', height: '40px' }} 
      />
      <span style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'sans-serif' }}>
        {Math.round(weather.current.temp_c)}°C
      </span>
  
    </div>
  );
};

export default WeatherMini;